export enum RFQStep {
    CHOOSE_MATERIALS = 'CHOOSE_MATERIALS',
    ADD_ITEMS = 'ADD_ITEMS',
    SHIPPING_DETAILS = 'SHIPPING_DETAILS',
}
